// extracted by mini-css-extract-plugin
export default {"modal":"Edit_modal__3gD7H","wrapper":"Edit_wrapper__0Rrfd","wrapper_button":"Edit_wrapper_button__sI9sc","loading":"Edit_loading__MZxEH"};